export default __webpack_public_path__ + "static/media/thirdstepmobile.5f00dc84.png";